export const SHARE_CART_BY_EMAIL_FORM = 'shareCartByEmail';
export const validationConfig = {
    shareCartByEmail: {
        name: {
            value: '',
            errors: [],
            isTouched: false,
        },
        email: {
            value: '',
            errors: ['required', 'regexp'],
            isTouched: false,
        },
    },
};
export const NAME_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 60;
